import { EnvironmentActions } from './environment.actions';
import { Action } from '@ngrx/store';

export const initialEnvAppState: IEnvironmentState = {environment: {} as string};

export function environmentReducer (state: IEnvironmentState = initialEnvAppState, action: any) {
switch (action.type) {
    case EnvironmentActions.ADD:
    return {...state, environment: action.payload};
    default:
    return state;
}
};
